import React from "react";
import {
  Typography,
  Box,
  Modal,
  Paper,
  SvgIcon,
  IconButton,
  FormControl,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  Button,
  Skeleton,
} from "@mui/material";
import { useAppSelector } from "src/hooks";
import { t, Trans } from "@lingui/macro";
import { ReactComponent as XIcon } from "src/assets/icons/x.svg";
import { ReactComponent as InviteIcon } from "src/assets/icons/logo.svg";
import { useMobile } from "src/hooks";
import { useWeb3Context } from "src/hooks";
import { LoadingButton } from "@mui/lab";
import { isPendingTxn, txnButtonText } from "src/slices/PendingTxnsSlice";
import TopIcon from "src/assets/images/tip-icon.png";
const TipModal = ({ open, handleClose }: any) => {
  const { isSmallScreen } = useMobile();
  const { connected, connect } = useWeb3Context();
  const pendingTransactions = useAppSelector(state => {
    return state.pendingTransactions;
  });
  return (
    <Modal
      id="tip-modal"
      open={open}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: isSmallScreen ? 1.875 : 0,
      }}
      onClose={handleClose}
      // hideBackdrop
    >
      <Box
        sx={{
          width: { xs: "345px", sm: "540px" },
          height: { xs: "360px", sm: "340px" },
          borderRadius: { xs: "6px", sm: "10px" },
          background: "linear-gradient(180deg, #362D00 0%, #151515 100%)",
          px: { xs: "15px", sm: "30px" },
          py: 2.5,
          border: "1px solid #2D2D2D",
        }}
      >
        <Box
          display="flex"
          justifyContent={"center"}
          alignItems="center"
          sx={{
            mb: { xs: "31px", sm: "39px" },
          }}
        >
          <Box
            sx={{
              width: "47px",
              height: "41px",
              mr: "10px",
              "&>img": {
                width: "100%",
                height: "100%",
              },
            }}
          >
            <img src={TopIcon} alt="tip-icon" />
          </Box>
          <Typography
            sx={{
              color: "#FCD000",
              fontSize: "24px",
              fontWeight: "600",
            }}
            align="center"
          >
            <Trans>Warm Tip:</Trans>
          </Typography>
        </Box>
        <Box
          sx={{
            mb: { xs: "36px", sm: "50px" },
          }}
        >
          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.90)",
              fontSize: { xs: "16px", sm: "18px" },
              fontWeight: "400",
              lineHeight: "1.1",
            }}
          >
            <Trans>
              Do not disclose passwords, private keys, mnemonics, Keystore files to others. Please use physical media to
              back up as much as possible (e.g., copying on paper), do not use third-party software such as WeChat, QQ,
              or email to transmit and save, and do not take screenshots or photos to save.
            </Trans>
          </Typography>
        </Box>
        <Box>
          <LoadingButton
            onClick={handleClose}
            sx={{
              width: "100%",
              borderRadius: "6px",
              height: "44px",
              border: "1px solid #000",
              background: "#FCD000",
              boxShadow: "-3px 3px 0px 0px #ECAA00",
              whiteSpace: "nowrap",
              "&:hover": {
                transform: "scale(1.02)",
                background: "#FCD000",
                boxShadow: "-3px 3px 0px 0px #ECAA00",
              },
              "&.Mui-disabled": {
                background: "#FCD000",
                boxShadow: "-3px 3px 0px 0px #ECAA00",
              },
            }}
          >
            <Typography
              sx={{
                color: "#000",
                textAlign: "center",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              <Trans>Understood.</Trans>
            </Typography>
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default TipModal;
